export default __webpack_public_path__ + "static/media/Dead_Devils_Society_Theme_2.993ef3a0.wav";